// extracted by mini-css-extract-plugin
module.exports = {"projects":"create-edit-project_projects__aOsXZ","header":"create-edit-project_header__1bHo9"};